'use client';

import {
    Button,
    ButtonList,
    ButtonVariant,
    Image,
    Modal,
    ModalBody,
    ModalFooter,
    Text,
    TextLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

type ErrorModalProps = {
    active: boolean;
    onClose: () => void;
    imgSrc?: string;
    title?: string;
    description?: string;
    primaryCta?: {
        label: string;
        action?: () => void;
    };
    secondaryCta?: {
        label: string;
        action?: () => void;
    };
};

export default function ErrorModal({
    active,
    onClose,
    imgSrc,
    title = 'Oups !',
    description,
    primaryCta,
    secondaryCta,
}: Readonly<ErrorModalProps>) {
    return (
        <Modal title={title} active={active} onClose={onClose}>
            <ModalBody>
                {imgSrc ? (
                    <div className='error-img-wrapper'>
                        <Image src={imgSrc} alt='Erreur' />
                    </div>
                ) : null}
                {description ? (
                    <Text typo={TypographyAlign.TEXT_LEFT} level={TextLevels.ONE}>
                        {description}
                    </Text>
                ) : null}
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    {secondaryCta && (
                        <Button variant={ButtonVariant.SECONDARY} onClick={() => secondaryCta.action?.()}>
                            {secondaryCta.label}
                        </Button>
                    )}

                    {primaryCta && (
                        <Button variant={ButtonVariant.CONVERSION} onClick={() => primaryCta.action?.()}>
                            {primaryCta.label}
                        </Button>
                    )}
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
